export default __webpack_public_path__ + "static/section_3_details_1-9cc6de93a9c7adda6b9ce5c78a1b7382.png";